(function() {
  angular.module('forgotUser')
  .controller('forgotUserController', ['$scope', '$q', 'forgotUserFactory', '$log','$state', '$timeout',
    function($scope, $q, forgotUserFactory, $log, $state, $timeout) {
      var vm = this;
      vm.submit = submit;
      vm.reset = reset;


      function submit() {
        $scope.errorControl.showErrors();
        if (!$scope.userIdForm.$valid) {
          return;
        }
        forgotUserFactory.get({'lastName': vm.model.lastName, 'taxId':vm.model.taxId}, function(data) {
          $scope.data = data;
          if($scope.data.multipleUsers) {
            $scope.errorMessage = "We have encountered an issue looking up your User id. Please contact support at (855) 260-3453";
          } else if(!$scope.data.users.length) {
            $scope.errorMessage = "We were unable to locate a user with the information provided";
          } else {
            $state.go('forgotUserIdConfirmation', {
              response : $scope.data
            });
          }
        });
      }

      function reset() {
        $scope.errorControl.hideErrors();
        $scope.errorMessage = '';
        vm.model = undefined;
      }
    }]);
})();
